export default {
  data() {
    return {}
  },
  methods: {
    startInteraction(proposition) {
      if (proposition === undefined) return

      let _this = this
      if (
        (proposition.loginRequired === true ||
          proposition.loginRequired === 'true' ||
          proposition.loginRequired === 'both') &&
        !this.loggedIn
      ) {
        //open login dialog
        this.$modal.show('login', {
          action: startInteraction,
          type: proposition.loginRequired,
          noLoginAction: proposition.noLoginAction || ''
        })
      } else {
        startInteraction()
      }

      function startInteraction() {
        _this.rootStore.setInteraction(proposition)

        if (proposition.printStoreCategory) {
          // const catId = proposition.printStoreCategory
          if (proposition.printStoreCollection) {
            if (proposition.printStoreProduct) {
              _this.$router.push({
                name: 'printStoreProduct',
                params: {
                  productId: proposition.printStoreProduct,
                  collectionId: proposition.printStoreCollection,
                  categoryId: proposition.printStoreCategory
                }
              })
            } else {
              _this.$router.push({
                name: 'printStoreCollection',
                params: {
                  collectionId: proposition.printStoreCollection,
                  categoryId: proposition.printStoreCategory
                }
              })
            }
          } else {
            _this.$router.push({
              name: 'printStoreCategory',
              params: { categoryId: proposition.printStoreCategory }
            })
          }
        } else if (proposition.destination === 'printSecured') {
          _this.$router.push({
            name: 'printOrder',
            query: {
              secure: true
            }
          })
        } else {
          _this.$router.push({
            name: proposition.destination
          })
        }
      }
    }
  },
  computed: {
    loggedIn() {
      return this.rootStore.loggedIn
    }
  }
}
